// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@100;300;400;700&family=Roboto:ital,wght@0,100;0,300;0,400;1,400&display=swap);"]);
// Module
exports.push([module.id, ".cstm-label{color:#069;font-family:Roboto;font-style:normal;font-weight:700;line-height:normal}", ""]);
// Exports
module.exports = exports;
